export interface WellheadInfo {
    wellheadId: string;
    title: string;
    edits?: EditInfo[] | undefined;
    addOrDeletions?: ProppantAddOrDeletion[] | undefined;
    [key: string]: string | number | EditInfo[] | ProppantAddOrDeletion[] | undefined;
}

export enum EditType {
    WELLHEAD_INFO = 'wellheadInfoEdit',
    PROPPANT_INFO = 'proppantInfoEdit',
    PROPPANT_DELETE = 'proppantDeleted',
    PROPPANT_ADD = 'proppantAdded',
    LOFA_INFO = 'lofaInfoEdit',
    LOFA_ADDED = 'lofaAdded',
    LOFA_DELETE = 'lofaDeleted',
}

export interface EditInfo {
    attributeName: string;
    oldValue: string | number;
    newValue: string | number;
    editType: EditType;
}

export interface ProppantAddOrDeletion {
    editType: EditType;
    proppant: string;
    volume: number | null;
    plannedVolPerBox: number | null;
}

export interface LOFAAddOrDeletion {
    lofaName: string;
    lofaVolume: number | undefined;
    milesFromWell: number | undefined;
    maxVolumeBox: number | undefined;
    sandPo: string;
    transportationPo: string;
    editType: EditType;
}

export interface ProppantInfo {
    proppantId: number | null;
    title: string | null;
    edits?: EditInfo[] | undefined;
    addOrDeletions?: LOFAAddOrDeletion[] | undefined;
    [key: string]: string | number | EditInfo[] | LOFAAddOrDeletion[] | undefined | null;
}
